import { gql } from '@apollo/client';

export default gql`
  query partnerOrganizations {
    partnerOrganizations {
      id
      name
    }
  }
`;
